import { useState } from 'react'
import Customupload from '../../../../components/UploadFile'
import Custompreviewimg from '../../../../components/PreviewUser'
import Style from './upload.module.scss'
import { HTTP } from '../../../../api/http'
import { RcFile } from 'antd/lib/upload'
import { message } from 'antd'
import { UPLOAD_FILE } from '../../../../api/uploadfileapi'
import imgUpload from '../../../../assets/img/icon_upload.png'
import CustomIcon from '../../../../components/IconUser'
export interface imgFile {
  baseUrl: string
  newFilePath: string
}

interface Props {
  dataSource: imgFile[]
  onChange: (e: imgFile[]) => void
  productCode?: string
  disabled?: boolean
  maxCount?: number // 可上传的数量
}

// 上传文件
const Uploadimg = (props: Props) => {
  const { dataSource, onChange, productCode, disabled, maxCount = 1 } = props
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })
  // 删除图片
  function onClickDel(index: string) {
    const arr = dataSource.filter((item) => item.newFilePath !== index)
    onChange(arr)
  }

  // 预览图片
  const onClickPreview = (cur: number) => {
    const arr = dataSource.map(
      (item) => `${item.baseUrl ? item.baseUrl : HTTP}${item.newFilePath}`,
    )
    setPreviewimg({
      data: arr,
      currentIndex: cur,
    })
  }

  const uploadimg = async (productCode: string, file: RcFile[]) => {
    try {
      const flag: any = await Promise.all(
        file.map((fileitem) => checkImageWH(fileitem, 140, 54)),
      )
      const a = flag.every((item: any) => item === true)
      if (a) {
        const resData = await UPLOAD_FILE(
          { productCode: productCode, type: 'brand' },
          file,
        )
        if (resData.code === 0) {
          const list = resData.data
          message.success('上传成功')
          const arr = [...dataSource, list]
          onChange(arr)
        }
      }
    } catch (error) {}
  }

  let top = 0
  // 上传之前处理图片
  const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
    if (file.name.length > 100) {
      message.error('上传失败')
      top = 0
      return false
    }
    if (FileList.length + dataSource.length > maxCount) {
      message.error(`上传失败：图片数量超出限制（${maxCount}张）`)
      top = 0
      return false
    }
    if (file.size > 1024 * 1024 * 2) {
      message.error('上传失败：图片大于2m')
      top = 0
      return false
    } else if (file.type.indexOf('image') === -1) {
      message.error('上传失败：请上传图片格式！')
      top = 0
      return false
    }
    top++
    // 防止重复提交
    if (top === FileList.length) {
      uploadimg(productCode ? productCode : '', FileList)
      top = 0
    }
    return false
  }

  const checkImageWH = async (file: RcFile, width: number, height: number) => {
    return new Promise(function (resolve, reject) {
      const filereader = new FileReader()
      filereader.onload = (e: any) => {
        const src = e.target ? e.target.result : ''
        const image = new Image()
        image.src = src
        image.onload = function () {
          if (image.naturalWidth > width || image.naturalHeight > height) {
            message.error({
              content: `上传失败:请上传尺寸宽小于${width}和高小于${height}的图片`,
            })
            reject(false)
          } else {
            resolve(true)
          }
        }
        image.onerror = reject
      }
      filereader.readAsDataURL(file)
    })
  }
  return (
    <div className={Style.fileimgbox}>
      <div className={Style.fileimglist}>
        {dataSource.map((item, index) => (
          <div className={Style.fileimgitem} key={index}>
            <div className={Style.fileimgiteminfo}>
              <img
                src={`${item.baseUrl ? item.baseUrl : HTTP}${item.newFilePath}`}
                alt=""
              />
              <div
                className={Style.filehide}
                onClick={() => onClickPreview(index)}
              >
                <div style={{ color: '#FFFFFF' }}>点击预览</div>
              </div>
              {disabled ? null : (
                <CustomIcon
                  type="icon-shanchu1"
                  onClick={() => onClickDel(item.newFilePath)}
                  className={Style.delicon}
                />
              )}
            </div>
          </div>
        ))}
        {disabled || dataSource.length >= maxCount ? null : (
          <Customupload
            accept={'.jpeg,.jpg,.png'}
            multiple
            uploadBtn={
              <div
                className={Style.uploadBtn}
                style={{ backgroundImage: `url(${imgUpload})` }}
              ></div>
            }
            beforeUpload={(a, b) => beforeUpload(a, b)}
            visibleFile={false}
            disabledUpload={disabled}
          />
        )}

        <Custompreviewimg
          onClose={() =>
            setPreviewimg({
              data: [],
            })
          }
          images={previewimg}
        />
      </div>
    </div>
  )
}

export default Uploadimg
import { useState } from 'react'
import Customupload from '../../../../components/UploadFile'
import Custompreviewimg from '../../../../components/PreviewUser'
import Style from './upload.module.scss'
import { HTTP } from '../../../../api/http'
import { RcFile } from 'antd/lib/upload'
import { message } from 'antd'
import { UPLOAD_FILE } from '../../../../api/uploadfileapi'
import imgUpload from '../../../../assets/img/icon_upload.png'
import CustomIcon from '../../../../components/IconUser'
export interface imgFile {
  baseUrl: string
  newFilePath: string
}

interface Props {
  dataSource: imgFile[]
  onChange: (e: imgFile[]) => void
  productCode?: string
  disabled?: boolean
  maxCount?: number // 可上传的数量
}

// 上传文件
const Uploadimg = (props: Props) => {
  const { dataSource, onChange, productCode, disabled, maxCount = 1 } = props
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })
  // 删除图片
  function onClickDel(index: string) {
    const arr = dataSource.filter((item) => item.newFilePath !== index)
    onChange(arr)
  }

  // 预览图片
  const onClickPreview = (cur: number) => {
    const arr = dataSource.map(
      (item) => `${item.baseUrl ? item.baseUrl : HTTP}${item.newFilePath}`,
    )
    setPreviewimg({
      data: arr,
      currentIndex: cur,
    })
  }

  const uploadimg = async (productCode: string, file: RcFile[]) => {
    try {
      const flag: any = await Promise.all(
        file.map((fileitem) => checkImageWH(fileitem, 140, 54)),
      )
      const a = flag.every((item: any) => item === true)
      if (a) {
        const resData = await UPLOAD_FILE(
          { productCode: productCode, type: 'brand' },
          file,
        )
        if (resData.code === 0) {
          const list = resData.data
          message.success('上传成功')
          const arr = [...dataSource, list]
          onChange(arr)
        }
      }
    } catch (error) {}
  }

  let top = 0
  // 上传之前处理图片
  const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
    if (file.name.length > 100) {
      message.error('上传失败')
      top = 0
      return false
    }
    if (FileList.length + dataSource.length > maxCount) {
      message.error(`上传失败：图片数量超出限制（${maxCount}张）`)
      top = 0
      return false
    }
    if (file.size > 1024 * 1024 * 2) {
      message.error('上传失败：图片大于2m')
      top = 0
      return false
    } else if (file.type.indexOf('image') === -1) {
      message.error('上传失败：请上传图片格式！')
      top = 0
      return false
    }
    top++
    // 防止重复提交
    if (top === FileList.length) {
      uploadimg(productCode ? productCode : '', FileList)
      top = 0
    }
    return false
  }

  const checkImageWH = async (file: RcFile, width: number, height: number) => {
    return new Promise(function (resolve, reject) {
      const filereader = new FileReader()
      filereader.onload = (e: any) => {
        const src = e.target ? e.target.result : ''
        const image = new Image()
        image.src = src
        image.onload = function () {
          if (image.naturalWidth > width || image.naturalHeight > height) {
            message.error({
              content: `上传失败:请上传尺寸宽小于${width}和高小于${height}的图片`,
            })
            reject(false)
          } else {
            resolve(true)
          }
        }
        image.onerror = reject
      }
      filereader.readAsDataURL(file)
    })
  }
  return (
    <div className={Style.fileimgbox}>
      <div className={Style.fileimglist}>
        {dataSource.map((item, index) => (
          <div className={Style.fileimgitem} key={index}>
            <div className={Style.fileimgiteminfo}>
              <img
                src={`${item.baseUrl ? item.baseUrl : HTTP}${item.newFilePath}`}
                alt=""
              />
              <div
                className={Style.filehide}
                onClick={() => onClickPreview(index)}
              >
                <div style={{ color: '#FFFFFF' }}>点击预览</div>
              </div>
              {disabled ? null : (
                <CustomIcon
                  type="icon-shanchu1"
                  onClick={() => onClickDel(item.newFilePath)}
                  className={Style.delicon}
                />
              )}
            </div>
          </div>
        ))}
        {disabled || dataSource.length >= maxCount ? null : (
          <Customupload
            accept={'.jpeg,.jpg,.png'}
            multiple
            uploadBtn={
              <div
                className={Style.uploadBtn}
                style={{ backgroundImage: `url(${imgUpload})` }}
              ></div>
            }
            beforeUpload={(a, b) => beforeUpload(a, b)}
            visibleFile={false}
            disabledUpload={disabled}
          />
        )}

        <Custompreviewimg
          onClose={() =>
            setPreviewimg({
              data: [],
            })
          }
          images={previewimg}
        />
      </div>
    </div>
  )
}

export default Uploadimg
